import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {AbstractNDropdownMenuItemComponent, IDropdownMenuItem} from "./n-dropdown-menu.component";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: "n-dropdown-menu-item",
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: ``,
  providers: [{ provide: AbstractNDropdownMenuItemComponent, useExisting: NDropdownMenuItemComponent }],
})
export class NDropdownMenuItemComponent implements OnInit {

  @Output() select = new EventEmitter<any>();
  @Input() id: any;
  @Input() tid: string;

  private _heading$ = new BehaviorSubject(null);
  private _description$ = new BehaviorSubject(null);
  private _counter$ = new BehaviorSubject(null);
  private _iconId$ = new BehaviorSubject(null);
  private _iconColor$ = new BehaviorSubject<string>(undefined);
  private _iconSize$ = new BehaviorSubject(14);
  private _url$ = new BehaviorSubject(null);
  private _disabled$ = new BehaviorSubject(false);
  private menuItem: IDropdownMenuItem;

  @Input() set heading(val: string) {
    this._heading$.next(val);
  }

  @Input() set description(val: string) {
    this._description$.next(val);
  }

  @Input() set counter(val: string) {
    if (val) {
      this._counter$.next(val);
    }
  }

  @Input() set disabled(val: boolean) { // deprecated
    this._disabled$.next(val);
  }

  @Input() set isDisabled(val: boolean) {
    this._disabled$.next(val);
  }

  @Input() set iconId(val: string) {
    this._iconId$.next(val);
  }

  @Input() set iconColor(val: string) {
    if (val) {
      this._iconColor$.next(val);
    }
  }

  @Input() set iconSize(val: number) {
    if (val) {
      this._iconSize$.next(val);
    }
  }

  @Input() set url(val: string) {
    if (val) {
      this._url$.next(val);
    }
  }

  ngOnInit() {
    this.menuItem = {
      id: this.getId(),
      divider: false,
      heading: this._heading$,
      description: this._description$,
      counter: this._counter$,
      disabled: this._disabled$,
      iconId: this._iconId$,
      iconColor: this._iconColor$,
      iconSize: this._iconSize$,
      url: this._url$,
      select: this.select,
      tid: this.tid,
      disabledSnapshot: () => this._disabled$.value,
      headingSnapshot: () => this._heading$.value
    };
  }

  getDropdownMenuItem(): IDropdownMenuItem {
    return this.menuItem;
  }

  private getId(): any {
    return this.id === undefined ? this : this.id;
  }

}
